module.exports = __webpack_public_path__ + "static/media/5-min-dr@2x.48f70be4.png";